// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"40627b3e","117":"479edff3","360":"485203d8","598":"c879024a","744":"3ce22e45","778":"e7f529ab","801":"cf866015"}[chunkId] + ".chunk.js";
};